import { Status, Tooltip } from '@mm/components';
import { TokenErrorInfo, tokenErrorMsg } from '@mm/state/model/ConnectionModel';
import classNames from 'classnames';
import React from 'react';
import { colors } from '../../../../../styles/colors';

type Props = {
  styles: any;
  token?: { errorInfo: TokenErrorInfo; missingScopes?: string[] };
  connectedTooltipMsg?: string;
};

export const OauthTokenStatus = ({
  token,
  styles,
  connectedTooltipMsg,
}: Props) => {
  const missingScopes = token?.missingScopes || [];
  const wrapperStyles = { display: 'flex', alignItems: 'center' };
  return token?.errorInfo ? (
    <Tooltip title={tokenErrorMsg('oauthToken', token.errorInfo)}>
      <div style={wrapperStyles}>
        <Status
          status="Failed to connect"
          color={colors.dustRed}
          className={classNames(styles.oauthStatus, styles.oauthStatusError)}
        />
      </div>
    </Tooltip>
  ) : missingScopes.length > 0 ? (
    <Tooltip
      title={`Some of the scopes the application requires are missing:
      ${missingScopes.join('; ')}`}
    >
      <div style={wrapperStyles}>
        <Status
          status="Connected"
          color={colors.orange}
          className={classNames(styles.oauthStatus, styles.oauthStatusWarn)}
        />
      </div>
    </Tooltip>
  ) : (
    <Tooltip title={connectedTooltipMsg}>
      <div style={wrapperStyles}>
        <Status
          status="Connected"
          color={colors.polarGreen}
          className={classNames(styles.oauthStatus, styles.oauthStatusSuccess)}
        />
      </div>
    </Tooltip>
  );
};
